import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const RefundWrap = styled.div`
  width: 600px;
  min-width: 328px;
  margin: 86px auto 200px auto;
  display: block;
  ${customMedia.lessThan('tablet')`
      max-width: 600px;
      width: 100%;
      margin: 0 0 150px 0;
    `}
`
const TelChoiceTabTitle = styled.p`
  font-family: NotoSansBold, sans-serif;
  font-size: 18px;
  line-height: 26px;
  margin: 0 0 12px 0;
  ${customMedia.lessThan('tablet')`
    font-size: 16px;
  `}
`
const RefundTerms = styled.div`
  display: flex;
  align-items: flex-start;
  font-family: NotoSansRegular, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 10px;

  ${customMedia.lessThan('tablet')`
    font-size: 12px;
    max-width: 500px;
    width: 100%;
    padding: 0;
  `}

  ${customMedia.lessThan('mobile')`
    margin: 0 0 12px 0;
  `}
`

const RefundTermCheckboxLabel = styled.label<{ active?: boolean }>`
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  width: 26px;
  height: 26px;

  input[type='checkbox'] {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  img {
    width: 26px;
    height: 26px;
  }

  ${customMedia.lessThan('tablet')`
    width: 20px;
    height: 20px;

    img {
      width: 20px;
      height: 20px;
    }
  `}
`

const RefundTermContent = styled.div`
  flex: 1;
  color: ${COLOR.black};
  white-space: pre-line;
  margin-left: 10px;
`

const RefundTermDetailButton = styled.button`
  font: inherit;
  font-size: inherit;
  line-height: inherit;
  color: ${COLOR.black};
  text-decoration: underline;
  cursor: pointer;
`

const RefundTermSuffixLabel = styled.label`
  cursor: pointer;
  color: ${COLOR.black};
`

const RefundSktNotice = styled.p`
  font-family: NotoSansRegular, sans-serif;
  font-size: 14px;
  color: ${COLOR.gray50};
  padding-left: 36px;
  white-space: pre-wrap;

  ${customMedia.lessThan('tablet')`
    font-size: 12px;
  `}
`

const RefundCaution = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 30px;
  font-family: NotoSansRegular, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${COLOR.gray50};
  white-space: pre-line;
  text-align: center;

  ${customMedia.lessThan('tablet')`
    font-size: 12px;
    line-height: 17px;
    margin-top: 30px;
    `}
`

const RefundSktNoticeRed = styled.span`
  color: ${COLOR.point1};
`

const SubScriptTitle = styled.h3`
  font-size: 24px;
  line-height: 35px;
  font-family: NotoSansBold, sans-serif;
  white-space: pre-line;
  margin: 70px 0 12px 0;
  color: ${COLOR.black};
  ${customMedia.lessThan('tablet')`
      margin: 50px 0 8px 0;
      font-size: 16px;
      line-height: 23px;
  `}

  ${customMedia.lessThan('mobile')`
    margin: 40px 0 8px 0;
  `}
`
const SubScriptDesc = styled.div`
  margin: 12px 0 33px;

  color: ${COLOR.gray50};
  white-space: pre-line;
  line-height: 20px;
  font-size: 14px;
  font-family: NotoSansRegular, sans-serif;
  color: ${COLOR.gray50};
  .warning {
    color: ${COLOR.point1};
  }

  ${customMedia.lessThan('tablet')`
    margin: 0 0 40px 0;
    max-width: 600px;
    width: 100%;
     font-size: 12px;
     line-height: 17px;   
  `}

  ${customMedia.lessThan('mobile')`
    margin: 0 0 40px 0;
  `}
`
export {
  RefundCaution,
  RefundSktNotice,
  RefundSktNoticeRed,
  RefundTermCheckboxLabel,
  RefundTermContent,
  RefundTermDetailButton,
  RefundTerms,
  RefundTermSuffixLabel,
  RefundWrap,
  SubScriptDesc,
  SubScriptTitle,
  TelChoiceTabTitle,
}
